import { cn } from "@/lib/utils";

const LEVEL_STYLES = {
  ok: { chip: "bg-success-soft text-success border-success/30", label: "In place" },
  low: { chip: "bg-info-soft text-info border-info/30", label: "Low" },
  medium: { chip: "bg-warning-soft text-warning border-warning/30", label: "Medium" },
  high: { chip: "bg-destructive-soft text-destructive border-destructive/30", label: "High" },
  na: { chip: "bg-secondary text-muted-foreground border-border", label: "N/A" },
  unknown: { chip: "bg-secondary text-muted-foreground border-border", label: "Unanswered" }
};

export function ReportOperationalRisk({ areas }) {
  return (
    <div className="overflow-hidden rounded-sm border border-border bg-card">
      <table className="w-full text-sm">
        <thead className="bg-muted/50">
          <tr className="text-left">
            <th className="px-4 py-3 font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Area</th>
            <th className="w-32 px-4 py-3 font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Status</th>
            <th className="px-4 py-3 font-mono-label text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Note</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {areas.map((area) => {
            const style = LEVEL_STYLES[area.level] || LEVEL_STYLES.unknown;
            return (
              <tr key={area.key}>
                <td className="px-4 py-3 align-top font-display text-[15px] font-medium text-foreground">
                  {area.title}
                </td>
                <td className="px-4 py-3 align-top">
                  <span
                    className={cn(
                      "inline-flex rounded-sm border px-2 py-0.5 font-mono-label text-[10px] uppercase tracking-[0.18em]",
                      style.chip
                    )}
                  >
                    {style.label}
                  </span>
                </td>
                <td className="px-4 py-3 align-top text-xs leading-relaxed text-muted-foreground">
                  {area.label}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
